import { createAction } from 'redux-actions'
import { detectAnyAdblocker } from 'just-detect-adblock'

export const SET_ADBLOCKER_STATUS = 'AdBlocker: Sets status to true if adblocker is active'

const setAdBlockerStatus = createAction(SET_ADBLOCKER_STATUS)

const detectAdBlocker = () => (dispatch) => {
  detectAnyAdblocker().then((detected) => {
    if (detected) {
      dispatch(setAdBlockerStatus(detected))
    }
  })
}

export const actionCreators = {
  detectAdBlocker,
}
